import TaxRegisAPI from '@/api/TaxRegisAPI.js';
import httpClient from '../../../api/axios-httpclient';

export default {
	getListTaxReturnRegis: async function(context, param) {
		let url = TaxRegisAPI.getAPIUrl() + '/paging';
		let res = await httpClient.postAsync(
			{
				url: url,
				data: param
			},
			true,
			false
		);

		context.commit('updateTaxReturnRegis', res.Data);

		return res;
	},

	/**
	 * Đăng ký tờ khai qua mạng
	 * */
	registerDeclaration: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: TaxRegisAPI.getAPIUrl() + '/registration',
				data: payload
			},
			true
		);

		// Trả kết quả
		return res;
	},

	/**
	 * Lấy tất cả tờ khai đã đăng ký
	 */
	loadTaxReturnRegis: async function(context, payload) {
		let url = TaxRegisAPI.getAPIUrl() + '/all';
		let res = await httpClient.getAsync({
			url: url,
			params: {
				taxCode: payload.TaxCode,
				type: payload.Type
			}
		});

		if (res.Data) {
			return res.Data;
		}
	},

	/**
	 * Kiểm tra xem mst này đã đăng ký tờ khai nào chưa?
	 */
	checkRegisterDecTax: async function(context) {
		let res = await TaxRegisAPI.getAsync(
			{
				url: TaxRegisAPI.getAPIUrl() + '/checkregisterdectax'
			},
			false,
			false
		);

		if (res.Success) {
			context.commit('updateHadRegisteredDeclaration', res.Data);
		} else {
			context.commit('updateHadRegisteredDeclaration', false);
		}
	}
};
